import { useViewportDeviceInternal } from './useViewportDeviceInternal';

export const useViewportDevice = () => {
  const { isLaptop, isTablet, isMobile, isMobileSmall } =
    useViewportDeviceInternal();

  const device: DeviceType = (() => {
    switch (true) {
      case isTablet:
        return 'tablet';
      case isMobileSmall:
        return 'mobileSmall';
      case isMobile:
        return 'mobile';
      case isLaptop:
        return 'laptop';
      default:
        return 'desktop';
    }
  })();

  const isPortableDevice = ['mobile', 'mobileSmall', 'tablet'].includes(device);

  return {
    device,
    isPortableDevice,
    isLaptop: device === 'laptop',
    isTablet: device === 'tablet',
    isMobile: device === 'mobile' || device === 'mobileSmall',
    isPortraitMobile: device === 'mobileSmall',
  };
};

export type DeviceType =
  | 'desktop'
  | 'laptop'
  | 'tablet'
  | 'mobile'
  | 'mobileSmall';
